'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
const CricketComentryOver = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-3 md:mb-0"><h3 className="text-16-tamil-600 md:text-16-tamil-600 text-020202 pb-2 leading-[1.5]">17 க்கு மேல் முடிவு</h3><p className="text-14-tamil-400 md:text-14-tamil-400 leading-[1.5] line-clamp-1 ">22 runs   6 0 0 6 4 6</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="text-16-tamil-700 md:text-16-tamil-600 text-020202 leading-[1.5] pb-2">கள்ஆர்எச் 156/4</h3>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col md:flex-row md:justify-between p-3 md:p-3 md:items-start">{t0}<div className="text-right">{t1}<div className="flex flex-col md:flex-row md:gap-4 gap-1 text-14-tamil-400 md:text-14-tamil-400 text-020202 leading-[1.5] line-clamp-1"><span className="text-14-tamil-400 text-020202 leading-[1.5] line-clamp-1">சி.ஆர்.ஆர் : 6.53</span><span className="text-14-tamil-400 text-020202 leading-[1.5] line-clamp-1">ஆர்.ஆர்.ஆர் : 8.53</span></div></div></div>;
    t3 = <hr className="border-F2CC42 my-2 md:my-2" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-14-tamil-600 md:text-14-tamil-600  leading-[1.5] line-clamp-1 text-020202 pb-2">வி. கோஹ்லி <span className="text-12-tamil-400 md:text-14-tamil-400 text-020202">66 (25)</span></p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex-1">{t4}<p className="text-14-tamil-600 md:text-14-tamil-600 leading-[1.5] line-clamp-1 text-020202">ஆர். அஸ்வின் <span className="text-12-tamil-400 md:text-14-tamil-400 text-020202">25 (11)</span></p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-FFF9E1 border-DCDCDC border-1 font-sans max-w-full mx-auto">{t2}{t3}<div className="flex flex-col md:flex-row md:justify-between p-3 md:p-3 gap-3 md:gap-0">{t5}<div className="text-right flex-1"><p className="text-14-tamil-600 md:text-14-tamil-600 text-020202 leading-[1.5] line-clamp-1 pb-2">வி. கோஹ்லி <span className="text-12-tamil-400 md:text-14-tamil-400 text-020202">66 (25)</span></p></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default CricketComentryOver;